<div *ngIf="counters.length > 0; else: elseBlock" fxLayout>
  <div> {{counters.length}} </div>
</div>

<ng-template #elseBlock>
  <div>{{utils.traslatei18n('all')}}</div>
</ng-template>